export default __webpack_public_path__ + "static/exit_light_w.ab11e4c4dc9b2ef0b4cc85daeef8a13a.png";